import { Component, OnInit } from '@angular/core';
import { Currency } from 'src/app/models/enums/currency';
import { CurrencyService } from 'src/app/services/currency.service';

@Component({
  selector: 'app-invoice-help',
  templateUrl: './invoice-help.component.html',
  styleUrls: ['./invoice-help.component.scss']
})
export class InvoiceHelpComponent implements OnInit {

  currentCurrency: Currency = Currency.BRL;

  constructor(
    private currencyService: CurrencyService
  ) { }

  ngOnInit(): void {
    this.currentCurrency = this.currencyService.getCurrentCurrency();
  }
}
